import { Editor } from '@tiptap/react';
import { Control } from '@/types/editor';

interface ControlButtonProps {
  control: Control;
  editor?: Editor;
  className?: string;
}

const ControlButton = ({ control, editor, className }: ControlButtonProps) => (
  <button
    data-tooltip-id='chenook-tooltip'
    data-tooltip-content={control.tooltip}
    className={
      className
        ? className
        : editor?.isActive(control.id)
          ? `btn btn-sm btn-accent`
          : `btn btn-sm`
    }
    onClick={control.command}
    disabled={control.disabled ?? false}
  >
    <control.icon size={17} />
  </button>
);

export default ControlButton;
